module.exports = __webpack_public_path__ + "static/media/ava3.5ce084e8.svg";